import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import DocumentService from '../../Services/documents.service';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service';
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service';
import PuffLoader from "react-spinners/PuffLoader";
import { ToastContainer, toast } from "react-toastify";

import holdingItemsIcon from '../../assests/images/Icons/holdingItems.svg';
import '../../pages/AccountCardDashboard/AccountCardDashboard.css';
import ClientService from '../../Services/client.service';
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import DescriptionIcon from '@mui/icons-material/Description';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal';
import cardMatchingIcon from '../../assests/images/Icons/cardMatching.svg';
import { saveAs } from 'file-saver';
import { useBack } from "use-back";
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import EditModal from '../../Components/EditModal/EditModal';
import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker';
import CustomYearDatePicker from '../../Components/Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import FormControlLabel from '@mui/material/FormControlLabel';
import Constants from '../../assests/Constants/constants';
import { Button, Modal, Popper, styled, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Box, Checkbox,
    Collapse, Autocomplete
} from '@mui/material';
import CustomDatePicker from '../../Components/Widgets/CustomDates/CustomDatePicker/CustomDatePicker';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { beautifyNumber } from '../../Utils/FormatNumber';
import CustomDropdown from '../../Components/CustomDropdown/CustomDropdown';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails';
import PaymentAcceptanceCreateEditModal from '../../Components/PaymentAcceptance/SubComponents/PaymentAcceptanceCreateEditModal';
import CustomMonthYearIndividualDatePicker from '../../Components/Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker';
import AutocompleteSelectFilter from '../../Components/Widgets/AutocompleteSelectFilter/AutocompleteSelectFilter';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import '../../pages/Document/Document.scss';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import { validateDocumentBeforeProcessing, validatePaymentAcceptanceItems } from '../../Utils/documentValidation'
import AssetService from '../../Services/assets.service';
import HoldingItemsTable from '../../Components/HoldingItems/SubComponents/HoldingItemsTable';
import JournalEntryDataGrid from '../../Components/JournalEntryies/SubComponents/JournalEntryDataGrid';
import DraggableModal from '../../Components/DraggableModal/DraggableModal';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';

registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it

// Helper function to adjust date to Israel time zone (UTC+2)
const adjustToIsraelTime = (date) => {
    const israelTimeOffset = 2 * 3600 * 1000; // 2 hours in milliseconds
    return new Date(date.getTime() + israelTimeOffset);
};

// Helper function to get the start of the year in Israel time
const getStartOfYear = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1); // Jan 1st of the given year
    return adjustToIsraelTime(startOfYear);
};

// Helper function to get the current month in Israel time
const getCurrentMonth = (date) => {
    const currentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0); // Last day of the current month
    return adjustToIsraelTime(currentMonth);
};



const formatDate = (startDate, endDate) => {
    const date = new Date(startDate);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const Enddate = new Date(endDate);
    const EndMonth = ('0' + (Enddate.getMonth() + 1)).slice(-2);
    const EndYear = Enddate.getFullYear();
    return `${EndMonth}/${EndYear} - ${month}/${year}`;
};

const formatYearRange = (dateRange) => {
    const [start, end] = dateRange.split(" - ");
    const startYear = new Date(start).getFullYear();
    const startMonth = new Date(start).getMonth() + 1; // getMonth() is zero-indexed
    const endMonth = new Date(end).getMonth() + 1;
    return `${startMonth}-${endMonth}/${startYear}`;
}

const formatDateNew = dateString => {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

const customStyles = {
    valueContainer: (base, state) => ({
        ...base,
        justifyContent: "center"
    }),
}

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
    ({ theme, width, height }) => ({
        marginBottom: "20px",
        "& .MuiToggleButton-root": {
            width: "150px",

            backgroundColor: "#ffffff", // Button background color
            transition: "background-color 0.3s, transform 0.3s", // Smooth transition effects
            "&:hover": {
                backgroundColor: "#e0e0e0", // Change background color on hover
                transform: "scale(1.05)", // Slightly increase size on hover
            },
            "&.Mui-selected": {
                backgroundColor: "#304FFF", // Selected button background color
                color: "#fff", // Selected button text color
                borderColor: "#304FFF", // Selected button border color
                "&:hover": {
                    backgroundColor: "#0069d9", // Darker shade on hover when selected
                },
            },
        },
    })
);


function HoldingItems() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    // const [data, setData] = useState([]);
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const [creatingDepositDoc, setCreatingDepositDoc] = useState(false);
    const [generatingDraft, setGeneratingDraft] = useState(false);
    const { goBack } = useContext(NavHistoryContext);
    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);
    const [editedItem, setEditedItem] = useState({});
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    const [startDate, setStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartDate');
        return storedDateString
            ? new Date(storedDateString)
            : new Date(new Date().getFullYear(), 0, 1); // January 1st
    });

    const [endDate, setEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('EndDate');
        return storedDateString
            ? new Date(storedDateString)
            : new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999); // December 31st, end of day
    });
    const [isMonthly, setIsMonthly] = useState(() => {
        return JSON.parse(localStorage.getItem('isMonthly')) || true;
    });
    const [data, setData] = useState([]);
    const [sortDate, setSortDate] = useState(new Date());
    const [startYearDate, setStartYearDate] = useState(new Date());
    const [endYearDate, setEndYearDate] = useState(new Date());
    const [sortCodesGroupOptions, setSortCodesGroupOptions] = useState([]);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [footerTotals, setFooterTotals] = useState({});
    const [transactions, setTransactions] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);


    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
    //for item edit

    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [statusCheck, setStatusCheck] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [showType, setShowType] = useState({ type: 'all', index: -1 });
    const [depositPdfBlob, setDepositPdfBlob] = useState(null);
    const [depositPdfVisible, setDepositPdfVisible] = useState(false);
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [editedJournalItem, setEditedJournalItem] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemToDelete, setItemToDelete] = useState({});
    const [depositJournalEntryData, setDepositJournalEntryData] = useState([]);
    /* ────────────────────────────────────────────────
     * extra local state / handlers used only for the
     * JournalEntryDataGrid that lives in “HoldingItems”
     * ──────────────────────────────────────────────── */
    const [currentRowData, setCurrentRowData] = useState(null);
    const [openInlineEditModal, setOpenInlineEditModal] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [addNewJournalEntry, setAddNewJournalEntry] = useState(false);
    const [complexDepositsChecked, setComplexDepositsChecked] = useState(false);
    const [debitCreditSum, setDebitCreditSum] = useState(0);

    /* helper to pass to the grid when it wants to report selection */
    const handleSelectRows = ids => setSelectedRows(ids);

    /* helper for month/year formatting (re‑use the one you already have elsewhere if you like) */
    const formatMonthYearDate = (d) =>
        new Intl.DateTimeFormat('en-GB', { month: '2-digit', year: 'numeric' })
            .format(new Date(d));

    /* open an external PDF in a new tab */
    const [openedIframeUrl, setOpenedIframeUrl] = useState('');
    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const openPdfInNewTab = (pdfUrl) => {
        setOpenedIframeUrl(pdfUrl ? pdfUrl : NoDocumentsPdf);
        setBigIframeModalOpen(true);
    };

    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setOpenedIframeUrl('');
    };

    /* show the inline dialog coming from JournalEntryDataGrid */
    const handleOpenDialog = (rowData, isAddMode = false) => {
        setCurrentRowData(rowData);
        setAddNewJournalEntry(isAddMode);
        setOpenInlineEditModal(true);
    };

    /* right‑click context‑menu action coming from the grid */
    const handleRightClickAction = (rowId, newStatus, rowObj) => {
        // implement whatever business‑logic you need here…
        console.log('Right‑click:', { rowId, newStatus, rowObj });
    };

    /* empty array until you fetch them (you already create/fill it further down) */
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);


    //new constants
    const [focused, setFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const handleStartYearDate = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setStartYearDate(newDate);
    }


    const handleEndYearDate = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setEndYearDate(newDate);
    }

    const [fetchType, setFetchType] = useState('HoldingItems');   // toggle value
    const dataGridRef = useRef(null);                             // will hold ref to JournalEntryDataGrid

    const handleFetchTypeChange = (_, newVal) => {
        if (newVal) setFetchType(newVal);
        // if you need to fetch journal entries: if (newVal === 'DepositJournalEntries') fetchDepositEntries();
    };


    const [typeToPassToChoose, setTypeToPassToChoose] = useState('');

    const isPurchaseOfEquipment = (item) => {


        if (!item) return false; // If the item is not found, allow processing
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === item.sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing



        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };

    const StyledPopper = styled(Popper)(({ theme }) => ({
        '& .MuiPaper-root': {
            borderRadius: 8,
            background: '#FFF',
            boxShadow: '0px 4px 8px rgba(0,0,0,0.32)',
        },
    }));

    // deposit-draft dropdown value
    const [depositAccountCard, setDepositAccountCard] = useState(null);

    // deposit options modal (custom date / description / per-item amount overrides)
    const [depositOptionsOpen, setDepositOptionsOpen] = useState(false);
    const [depositCustomDate, setDepositCustomDate] = useState(new Date());
    const [depositDescription, setDepositDescription] = useState('');
    // snapshot of the rows the user chose, captured when the modal opens
    const [depositSelectedRows, setDepositSelectedRows] = useState([]);
    // { [transactionId]: string } – per-item overridden amount (blank = keep original)
    const [depositItemAmounts, setDepositItemAmounts] = useState({});
    // For checks only: when true (and >1 check selected) generate a separate deposit + journal entry per check;
    // otherwise (default) generate a single combined deposit + journal entry for all selected checks.
    const [oneDepositPerCheck, setOneDepositPerCheck] = useState(true);


    const holdingTypeOptions = {
        0: t('CreditCard'),
        1: t('Check'),
        2: t('BankTransfer'),
        3: t('Cash')
    };



    const handleHoldingTypeChange = async (newVal) => {
        if (!newVal) return;

        setHoldingItemType(newVal);
        if (client && token) await fetchEnums(user, token, client, startDate, endDate, newVal);
    };

    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });
    const handleCancel = () => {
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
    };


    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '' })
        setEditedAddAccountCard(false);
    };


    const handleEditAddAccountChange = (selectedOption, field) => {

        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedItem({ ...editedItem, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'AccountCodeName') {
            setEditedItem({ ...editedItem, accountCodeName: selectedOption })
        }
        else {
            setEditedItem({ ...editedItem, accountCaseId: selectedOption })

        }
    };

    /* ― shared Autocomplete visuals ― */
    const sharedInputProps = {
        disableUnderline: true,
        className: "custom-input-box-sizing-toggle",
        sx: {
            height: "48px",
            padding: "0 10px",
            borderRadius: "8px",
            background: "#F5F5F6",
            border: "1px solid transparent",
            "&:focus-within": {
                border: "2px solid var(--Foundation-Blue-Normal, #304FFF)",
            },
        },
    };

    const sharedInputStyle = dir => ({
        style: { textAlign: dir === "ltr" ? "left" : "right" },
    });




    const updateAccountFields = (newValue, accountType) => {


        const isIncomesDebit = editedItem.docType === 'Incomes' && accountType === 'debitAccount';
        const isExpensesCredit = editedItem.docType === 'Expenses' && accountType === 'creditAccount';

        const updatedFields = {
            accountCodeId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.cardId : '') : '',
            accountCodeName: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.name : '') : '',
            accountCaseId: isIncomesDebit || isExpensesCredit ? (newValue ? newValue.accountCaseId : '') : '',
        };

        // Update the edited item with the new fields
        setEditedItem((prev) => ({
            ...prev,
            [accountType]: newValue ? newValue.cardId : '',
            ...(isIncomesDebit || isExpensesCredit ? updatedFields : {}),
        }));
    };

    const { hasBack, handleBack } = useBack();


    const handleChange = (field, value) => {

        const updatedValue = value;

        if (field === 'sortCodeId') {
            let depreciation = false;


            if (!value || !sortCodeIdOptions.some((option) => option.sortCodeId === value)) {
                // Set default values for the empty state
                setEditedItem({
                    ...editedItem,
                    vat: 100, // Default VAT
                    [field]: '',
                });
                return; // Exit early since there's no valid sortCodeId
            }

            const name = sortCodeIdOptions.find(
                (option) => option.sortCodeId === value
            )?.sortCodeName || ''

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;


            const sortCode = sortCodeIdOptions.filter(sc => sc.sortCodeId === updatedValue)[0];

            // Determine the VAT based on the name without parentheses
            const newVat = sortCode?.vat ?? 100;


            const accountCard = accountCardOptions.find(
                (item) => item.cardId === (type === 'Incomes' ? sortCode.debitAccount : sortCode.creditAccount)
            );
            setEditedItem({
                ...editedItem,
                vat: newVat,
                [field]: updatedValue,
                [type === 'Incomes' ? 'debitAccount' : 'creditAccount']:
                    editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount']
                        ? (accountCard ? accountCard.cardId : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'])
                        : editedItem[type === 'Incomes' ? 'debitAccount' : 'creditAccount'],
                accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
                accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
                accountCaseId: accountCard ? accountCard.accountCaseId : editedItem.accountCaseId,
            });

        }
        else if (field === 'creditAccount' || field === 'debitAccount') {

            // Use the helper function to update account fields for credit or debit account
            const newValue = accountCardOptions.find(option => option.cardId === updatedValue) || null;
            updateAccountFields(newValue, field);
        }
        else {
            // For fields other than sortCodeId, just update the edited item
            setEditedItem({
                ...editedItem,
                [field]: updatedValue,
            });
        }
    };
    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };

    const handleReopenEdit = async (item, index) => {
        await fetchEnums(user, token, client);
        item.key = item.id;
        handleEdit(item, index);
    };


    const handleAccountChange = (selectedOption, field) => {
        if (field === 'debitAccount' || field === 'creditAccount') {
            const accountCardEditDownload = accountCardEditDownloadOptions.find(option => option.cardId === selectedOption.value);
            const name = accountCardEditDownload?.name;
            const accountCaseId = accountCardEditDownload?.accountCaseId;
            if (selectedOption.value < 0) {

                setOriginalAccountCardId(editedItem.cardId)
            }
            if (editedItem.docType === 'Incomes') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, debitAccount: selectedOption.value, accountCaseId: accountCaseId })
            }
            else if (editedItem.docType === 'Expenses') {
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, creditAccount: selectedOption.value, accountCaseId: accountCaseId });
            }
            else if (editedItem.docType === 'JournalEntries') {
                setEditedItem({
                    ...editedItem,
                    [field]: selectedOption.value
                });
            }
        } else if (field === 'accountCodeName') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' })
            }
            else {
                const accountCardEdit = accountCardEditDownloadOptions.find(option =>
                    option.cardId === selectedOption.value
                );
                const name = accountCardEdit?.name;
                const accountCaseId = accountCardEdit?.accountCaseId;
                const cardId = selectedOption.value;
                if (editedItem.docType === 'Incomes') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, debitAccount: cardId, accountCaseId: accountCaseId })
                }
                else if (editedItem.docType === 'Expenses') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, creditAccount: cardId, accountCaseId: accountCaseId });
                }
                else if (editedItem.docType === 'JournalEntries') {
                    setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, accountCaseId: accountCaseId })
                }
            }
        }
    };
    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="document-custom-input1" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return
            }
            else {
                setEditedItem({ ...editedItem, [field]: newDate });
            }
        }
    }

    const handleRadioPAChange = async (e) => {
        if (e.target.value?.toString() === 'done') {
            const isValid = await validatePaymentAcceptanceItems(addEditableItem, t, client);
            if (!isValid) return;

            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }
        setAddEditableItem({ ...addEditableItem, ["status"]: e.target.value });
    };

    const handleRadioChange = async (e, options = {}) => {
        if (e.target.value?.toString() === 'done' && !options?.validationAlreadyDone) {

            const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, options?.forceProcess === true);
            if (!isValid) return;
        }

        if (e.target.value?.toString() === 'done') {
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }

        setEditedItem({ ...editedItem, status: e.target.value });
    };
    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };
    const handleUpdate = async (item) => {

        setLoading(true);
        let finalResponse = null;
        const documentUrl = editedItem.documentUrl;
        // Don't close the modal - removed setEditedPopupItem(false);
        try {
            editedItem.accountCaseId = client.accountCaseId;
            delete editedItem.documentUrl; // Ensure the document URL is not part of the update if present

            setTypeToPassToChoose(editedItem.docType);

            finalResponse = await DocumentService.UpdateDocument(editedItem.docType, token, editedItem);
            if (finalResponse && finalResponse.ok) {
                // Reassign documentUrl back to editedItem after successful update
                editedItem.documentUrl = documentUrl;

                if (editedItem.status === 'done') {
                    await handleDoneClick(editedItem.id, editedItem.docType);
                } else if (editedItem.status === 'notDone') {
                    await handleNotDoneClick(editedItem.id, editedItem.docType);
                }

                if (editedAddAccountCard) {
                    await handleAccountCardSave(editedItem.accountCodeId, editedItem.accountCodeName, editedItem.accountCaseId);
                    await fetchEnums(user, token, client);
                }

                // Refresh data after successful update
                if (isRange) {
                    await fetchDataOnDateRangeChange(startDate, endDate);
                } else {
                    await fetchDocuments(sortDate);
                }
                await fetchEnums(user, token, client);

                const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                    ? endDate
                    : new Date(Date.UTC(startDate.getFullYear(), 11, 31));
                setEndDate(finalEndDate);
                toast.success(t("documentUpdateSuccess"));
            } else {
                // Reassign documentUrl back to editedItem even on error to maintain state
                editedItem.documentUrl = documentUrl;

                const errorText = await finalResponse.text();
                toast.error(t("documentUpdateError") + ": " + errorText);
            }
        } catch (error) {
            // This block catches unexpected errors such as network issues, not HTTP errors which are handled above
            console.error("Unexpected error occurred: ", error);
            toast.error(t("documentUpdateError"));
            // Reassign documentUrl back to editedItem on catch error to maintain state
            editedItem.documentUrl = documentUrl;
        }
        // Don't clear the edited item or close the modal - removed these lines:
        // setEditedItem({});
        // setEditingRow(null);
        // setEditedAddAccountCard(false);
        setLoading(false); // Always stop loading at the end of the operation
    };

    const handleDoneClick = async (itemId, docType) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, docType, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };

    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
        // Enrich clients with their total document counts
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts.totalCounts || 0, // Default to 0 if no matching count is found
            documentCounts: documentCounts.documentCounts || {},
            documentIds: documentCounts.documentIds || {},
        };
        setClient(enrichedClient);
    }
    const handleNotDoneClick = async (itemId, docType) => {
        setLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, docType, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLoading(false);
    };
    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, AccountCaseId) => {
        const response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, AccountCaseId, token);
        if (!response2.ok) {
            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const [assets, setAssets] = useState([]);
    const [holdingItems, setHoldingItems] = useState([]);

    const [holdingItemType, setHoldingItemType] = useState('1');
    const optionKeys = Object.keys(holdingTypeOptions);   // ["0","1","2","3"]
    const holdingTypeSelectOptions = optionKeys.map((key) => ({ value: key, label: holdingTypeOptions[key] }));

    const [formattedAccountCardOptions, setFormattedAccountCardOptions] = useState([]);
    //FetchEnums
    const fetchEnums = async (user, token, client, start, end, typeHolding = null) => {

        setLoading(true);
        let startDateToFetch = start || startDate;
        let endDateToFetch = end || endDate;

        // Ensure startDate and endDate are set
        if (!startDateToFetch || !endDateToFetch) {
            const currentYear = new Date().getFullYear();
            const startOfYear = new Date(Date.UTC(currentYear, 0, 1));
            const endOfYear = new Date(Date.UTC(currentYear, 11, 31));
            startDateToFetch = startOfYear;
            endDateToFetch = endOfYear;
            setStartDate(startOfYear);
            setEndDate(endOfYear);
        }
        try {

            const selectedType = typeHolding ?? holdingItemType;

            //Fetch holding items

            try {
                const data = await DocumentService.GetHoldingItems(
                    client.caseId,
                    startDateToFetch?.toISOString(),
                    endDateToFetch?.toISOString(),
                    parseInt(selectedType, 10),
                    token,
                    false // isDeposited
                );
                setHoldingItems(data);
            } catch (err) {
                toast.error(err.message);
            }

            const res = await DocumentService.GetDepositedJournalEntriesByDate(
                client.caseId,
                startDate.toISOString(),
                endDate?.toISOString(),   // send null if you only need one date
                token
            );
            const rows = await res.json();
            setDepositJournalEntryData(rows);

            const sortCodeGroupResponse = await EnumsService.GetSortCodesGroupByAccountantId(client.accountantId, token);
            const sortCodeGroupData = await sortCodeGroupResponse.json();
            setSortCodesGroupOptions(sortCodeGroupData);

            // Fetching sortCodeIdOptions
            const codeIdResponse = await EnumsService.GetSortCodesByAccountantId(client.accountantId, token);
            if (codeIdResponse.ok) {
                const codeIdData = await codeIdResponse.json();
                setSortCodeIdOptions(codeIdData); // Assuming codeIdData is already in the correct format
            }


            // Fetching creditAccountOptions and debitAccountOptions
            const accountsResponse = await EnumsService.GetAccountCardsByCaseId(client.caseId, token);
            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setCreditAccountOptions(accountsData);
                setDebitAccountOptions(accountsData); // Assuming both options are the same
                setAccountCardEditDownloadOptions(accountsData);
                const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];
                // build dropdown options once accountsData arrives
                const formattedAccountCardOptions = accountsData.map(a => ({
                    value: a.cardId,
                    cardId: a.cardId,
                    name: a.name,
                    label: `${a.cardId} - ${a.name}`,
                }));
                setFormattedAccountCardOptions(formattedAccountCardOptions);
                setAccountCardOptions(accountCardOptions);
            }

            const palCodesResponse = await EnumsService.GetPalCodesByAccountantId(client.accountantId, token);
            // Process palCodes if response is okay
            if (palCodesResponse.ok) {
                const palCodesData = await palCodesResponse.json();
                const formattedPalCodes = palCodesData.map(palCode => ({
                    label: palCode.palCodeId,
                    value: palCode.palCodeId
                }));

                setFormattedPalCodeOptions(formattedPalCodes);
            }

            setIsDataFetched(true);
            // toast.success(t('enumFetchSuccess'));
        } catch (error) {
            console.error("Error fetching enum data:", error);
            toast.error(`${t("Error fetching enum data")}: ${error}`);
        }
        setLoading(false);
    };

    const handleRangeChange = () => {
        setIsMonthly(prevIsMonthly => {
            const newIsMonthly = !prevIsMonthly;
            localStorage.setItem('isMonthly', JSON.stringify(newIsMonthly));
            return newIsMonthly;
        });
    };



    const handleEndDateChange = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        let endDateToSet;

        if (isMonthly) {
            endDateToSet = newDate;
            setEndDate(newDate);
        } else {
            endDateToSet = new Date(Date.UTC(date.getFullYear(), 11, 31));
            setEndYearDate(endDateToSet);
            setEndDate(endDateToSet);
        }

        const startOfYear = new Date(Date.UTC(startDate.getFullYear(), 0, 1));
    };



    const handleStartDateChangeNew = async (newValue, type) => {

        const newDate = new Date(newValue);
        let updatedDate;
        let startDateToSet;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 10));
        }

        if (isMonthly) {
            startDateToSet = updatedDate;
            setStartDate(updatedDate);
            localStorage.setItem('StartDate', updatedDate.toISOString()); // Save to localStorage
        } else {
            startDateToSet = new Date(Date.UTC(newDate.getFullYear(), 0, 1));
            setStartYearDate(startDateToSet);
            setStartDate(startDateToSet);
            localStorage.setItem('StartYearDate', startDateToSet.toISOString()); // Save to localStorage
        }
        // Save the updated date in localStorage for persistence
        const endOfYear = new Date(Date.UTC(endDate.getFullYear(), 11, 31));
        await fetchEnums(user, token, client, updatedDate, endDate);

    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;
        let endDateToSet;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 10));
        }
        if (isMonthly) {
            endDateToSet = updatedDate;
            setEndDate(updatedDate);
            localStorage.setItem('EndDate', updatedDate.toISOString()); // Save to localStorage
        } else {
            endDateToSet = new Date(Date.UTC(newDate.getFullYear(), 11, 31));
            setEndYearDate(endDateToSet);
            setEndDate(endDateToSet);
            localStorage.setItem('EndYearDate', endDateToSet.toISOString()); // Save to localStorage
        }

        const startOfYear = new Date(Date.UTC(startDate.getFullYear(), 0, 1));
        await fetchEnums(user, token, client, startDate, updatedDate);

    };
    //for item edit
    function formatDate(input) {
        const [datePart, timePart] = input.split(' ');
        const [day, month, year] = datePart.split('/');
        const date = new Date(year, month - 1, day);
        if (timePart) {
            const [hours, minutes, seconds] = timePart.split(':');
            date.setHours(hours, minutes, seconds, 0);
        }
        return date.toISOString().slice(0, 19) + '.000';
    }
    //payment functions
    const [openInvoiceCreatorModal, setOpenInvoiceCreatorModal] = useState(false);
    const [addEditableItem, setAddEditableItem] = useState({
        checks: [],
        creditCards: [],
        cash: [],
        bankTransactions: [],
        offsets: [],
        date: new Date()
    });
    const [modalVisible, setModalVisible] = useState(false);
    const [itemEditing, setItemEditing] = useState(true);
    const [addNewAccountCard, setAddNewAccountCard] = useState(false);
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const isClosedReportingMonthAndIsRange = !isRange ? isClosedReportingMonth : addEditableItem.isClosedReportingMonth;
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [paymentAcceptanceItems, setPaymentAcceptanceItems] = useState([]);
    const [accountCodeName, setAccountCodeName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [accountCodeId, setAccountCodeId] = useState('');
    const [invoiceClientCaseId, setInvoiceClientCaseId] = useState('');
    const [accountType, setAccountType] = useState(null);
    const [description, setDescription] = useState('');
    const [showAccountCardInputsEdit, setShowAccountCardInputsEdit] = useState(false);
    const [acceptedWithholdingTax, setAcceptedWithholdingTax] = useState(0);
    const [palCode, setPalCode] = useState('');
    const [paymentWithholdingTax, setPaymentWithholdingTax] = useState(0);
    const [newItem, setNewItem] = useState(false);
    const [isUpdated, setIsUpdated] = useState(false);
    const [actionType, setActionType] = useState('delete');
    const [accountCardIdToDelete, setAccountCardIdToDelete] = useState('');
    const [paymentBeingEdited, setPaymentBeingEdited] = useState(true);

    const handleAddAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLoading(true);
            const response = await EnumsService.AddAccountCard(client.caseId, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const accountCodeId = await response.json();
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };

                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                setAccountCardOptions(prevCards => {
                    const updatedCards = [...prevCards, selectedAccountCard];
                    setIsUpdated(true);
                    return updatedCards;
                });

                toast.success(t('CustomerSupplierAddedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('Failed to edit user', errorText);
                toast.error(t('FailedToAddCustomerSupplier'));
            }
        } catch (error) {
            console.error('Error edit user:', error);
            toast.error(t('FailedToAddCustomerSupplier'));
        }
        setLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };
    const handleAddEditableItemChange = (name, value) => {

        setAddEditableItem(prev => ({ ...prev, [name]: value }));

    };

    async function fetchDataOnDateRangeChange(startDate, endDate) {

        setLoading(true)
        const formattedStartDate = startDate.toISOString();
        const formattedEndDate = endDate.toISOString();

        try {
            const response = await DocumentService.GetDocumentbyDateRange(type, client.caseId, formattedStartDate, formattedEndDate, token)
            if (response.ok) {
                const data = await response.json(); // Parse the JSON in the response
                extractVatByType(data);
                setData(data);
                // toast.success(t('documentFetchSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentFetchError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentFetchError', { errorText: error.message }));
        }

        setLoading(false)
    }
    const [oldSelectedAccountCardItem, setOldSelectedAccountCardItem] = useState({
        cardId: "",
        caseId: "",
        accountCaseId: "",
        name: "",
        palCode: '',
        client: null
    });
    const [originalTaxClearance, setOriginalTaxClearance] = useState(null);
    const extractVatByType = (data) => {


        // Sum the WithholdingTax based on PaymentAcceptanceType
        let acceptedWithholdingSum = 0;
        let paymentWithholdingSum = 0;
        let creditSum = 0;
        let debitSum = 0;
        let total = 0;
        data.forEach(doc => {

            if (doc.paymentAcceptanceType === 'תקבול') {
                acceptedWithholdingSum += doc.withholdingTax || 0;
            } else if (doc.paymentAcceptanceType === 'תשלום') {
                paymentWithholdingSum += doc.withholdingTax || 0;
            }
            total += doc.amount
            creditSum += doc.creditAccountAmount || 0;
            debitSum += doc.debitAccountAmount || 0;
        });
        let diff = debitSum - creditSum;
        setAcceptedWithholdingTax(acceptedWithholdingSum);
        setPaymentWithholdingTax(paymentWithholdingSum);
    };

    const CustomPalCode = (props) => {
        return (
            <div style={{ textAlign: 'center', width: '100%' }}>{props.label}</div>
        );
    };

    const setAccount = (field, input) => {
        //switch case on field
        switch (field) {
            case 'companyId':
                setCompanyId(input);
                setInvoiceClientCaseId(input);

                break;
            case 'accountCodeName':
                setAccountCodeName(input);

                break;
            case 'accountCodeId':
                setAccountCodeId(input);

                break;
            default:

        }
    }

    const checkIfExistingAccountCard = (accountCardOptions, cardId, accountCaseId, edit = false) => {
        const existingAccountCard = accountCardOptions.filter(card =>
            (card.accountCaseId === accountCaseId && accountCaseId) ||
            (card.cardId === cardId && cardId)
        );
        const isExist = existingAccountCard && (edit
            ? existingAccountCard.length > 1
            : existingAccountCard.length > 0);
        if (isExist) {
            toast.info(t('AccountCardExists', { accountCodeId: existingAccountCard.cardId }));
            return true;
        }
    }
    const fetchDocuments = async (selectedDate) => {
        setLoading(true);
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));

        try {
            const response = await DocumentService.GetDocumentbyDate(type, client.caseId, newDate, token)
            const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);

            if (response.ok && response1.ok) {
                const data = await response.json(); // Parse the JSON in the response
                const isClosedReportingMonth = await response1.json();
                setIsClosedReportingMonth(isClosedReportingMonth);
                extractVatByType(data);
                setData(data);
                // toast.success(t('fetchDocumentsSuccess'));
            } else {
                const errorText = await response.text();
            }
        } catch (error) {

            toast.error(t('errorFetchingDocuments'));
        }
        setLoading(false);
    };

    const handleCloseAddNewAccountCardDocument = () => {
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
    };
    const onRefresh = async () => {
        setLoading(true);
        await fetchUserData();
        if (!isRange)
            fetchDocuments(sortDate);
        else
            fetchDataOnDateRangeChange(startDate, endDate)
        await fetchEnums(user, token, client);
    };
    const handleSave = async () => {


        try {
            setModalVisible(false);
            setOpenInvoiceCreatorModal(false);
            setLoading(true);
            // Prepare the data to be sent in the request body
            const updatedDocument = {
                id: addEditableItem.id,
                caseId: addEditableItem.caseId,
                accountCodeName: addEditableItem.accountCodeName,
                accountCodeId: addEditableItem.accountCodeId,
                reference: addEditableItem.reference,
                amount: addEditableItem.amount,
                uploadDate: addEditableItem.uploadDate,
                paymentAcceptanceType: addEditableItem.paymentAcceptanceType,
                description: addEditableItem.description,
                withholdingTax: addEditableItem.withholdingTax,
                accountCaseId: addEditableItem.accountCaseId,
                checks: addEditableItem.checks,
                creditCards: addEditableItem.creditCards,
                cash: addEditableItem.cash,
                bankTransactions: addEditableItem.bankTransactions,
                date: addEditableItem.date ? new Date(addEditableItem.date).toISOString() : new Date().toISOString(),
                reportingMonthDate: new Date(addEditableItem.reportingMonthDate).toISOString(),
                confirmationNumber: addEditableItem.confirmationNumber,
                creditAccount: addEditableItem.creditAccount,
                creditAccountAmount: addEditableItem.creditAccountAmount,
                debitAccount: addEditableItem.debitAccount,
                debitAccountAmount: addEditableItem.debitAccountAmount,
                DeferredReceipt: addEditableItem.deferredReceipt
            };


            // Call the UpdateDocument function from DocumentService
            const response = await DocumentService.UpdateDocument("PaymentAcceptances", token, updatedDocument);

            if (response.ok) {
                // Handle successful update
                if (addEditableItem.status === 'done') {
                    await handleDoneClick(addEditableItem.id);
                } else if (addEditableItem.status === 'notDone') {
                    await handleNotDoneClick(addEditableItem.id);
                }
                toast.success(t('documentUpdateSuccess'));
            } else {
                // Handle any errors or display an error message
                toast.error(t('documentUpdateError'));
            }
        } catch (error) {
            console.error('documentUpdateError:', error);
            // Show an error toast message
            toast.error(t('documentUpdateError'));
        }
        await onRefresh();
        // handleClose(); // Function to revert or exit the edit mode
        setLoading(false);

    };

    const selectedAmount = useMemo(() => {
        if (selectedIds.length === 0 || !holdingItems) return 0;

        /* flatten checks / cash / credit-cards / bank-transfers */
        const rows = [];
        (holdingItems.paymentAcceptances || []).forEach(pa => {
            [pa.checks, pa.cash, pa.creditCards, pa.bankTransactions].forEach(arr =>
                arr?.forEach(tr => rows.push(tr))
            );
        });

        return rows
            .filter(r => selectedIds.includes(r.id))
            .reduce((tot, r) => tot + ((r.remainingAmount ?? r.amount) || 0), 0);
    }, [holdingItems, selectedIds]);

    const handleSaveEditAccountCard = async () => {
        if (checkIfExistingAccountCard(accountCardOptions, accountCodeId, companyId, true)) {
            return;
        }
        const Item = addEditableItem;
        handleClose();
        try {
            setLoading(true)

            const response = await EnumsService.UpdateAccountCard(client.caseId, oldSelectedAccountCardItem.cardId, oldSelectedAccountCardItem.name, accountCodeId, accountCodeName, companyId, palCode, token);
            if (response.ok) {
                const newItem = {
                    ...Item,
                    accountCodeId: accountCodeId?.toString(),
                    accountCodeName: accountCodeName?.toString(),
                    accountCaseId: invoiceClientCaseId?.toString(),
                };
                setNewItem(newItem);
                let selectedAccountCard = {
                    cardId: accountCodeId,
                    caseId: client.caseId,
                    accountCaseId: companyId,
                    name: accountCodeName,
                    palCode: palCode,
                    client: null
                };
                setAccountCardOptions(prevCards => {
                    const updatedCards = prevCards.filter(card => card.cardId !== selectedAccountCard.cardId);
                    updatedCards.push(selectedAccountCard);
                    setIsUpdated(true);
                    return updatedCards;
                });
                // handleReopenEdit(editedItem);
                toast.success(t('CustomerSupplierUpdatedSuccessfully'));
                setSelectedOption(selectedAccountCard ? selectedAccountCard : null);

            } else {
                const errorText = await response.text();
                console.error('FailedToUpdateCustomerSupplier', errorText);
                toast.error(t('FailedToUpdateCustomerSupplier'));
            }
        } catch (error) {
            console.error('FailedToUpdateCustomerSupplier:', error);

            toast.error(t('FailedToUpdateCustomerSupplier'));

        }
        setLoading(false);
        setPalCode('');
        setAccountCodeId("");
        setAccountCodeName("");
        setAddNewAccountCardDocument(false);
        setShowAccountCardInputsEdit(false);
    };

    const handleItemChange = (type, index, field, value) => {
        setPaymentAcceptanceItems(prevItems => {
            let typeIndex = -1;
            const updatedItems = prevItems.map((item, idx) => {
                if (item.type === type) {
                    typeIndex += 1;
                    if (typeIndex === index) {
                        return { ...item, [field]: value };
                    }
                }
                return item;
            });

            // Update the corresponding field in addEditableItem
            setAddEditableItem(prevItem => {
                const updatedTypeItems = prevItem[type].map((item, idx) => {
                    if (idx === index) {
                        return { ...item, [field]: value };
                    }
                    return item;
                });

                // Conditionally update the fields based on payment type and field
                const paymentType = addEditableItem.paymentAcceptanceType;
                const shouldUpdateFields =
                    (paymentType === 'תקבול' && field === 'creditAccount') ||
                    (paymentType === 'תשלום' && field === 'debitAccount');

                const matchingOption = accountCardOptions.find(
                    option => option.cardId === value
                );

                const updatedFields = shouldUpdateFields && matchingOption
                    ? {
                        accountCaseId: matchingOption.accountCaseId || '',
                        accountCodeId: matchingOption.cardId || '',
                        accountCodeName: matchingOption.name || '',
                    }
                    : {};

                return { ...prevItem, ...updatedFields, [type]: updatedTypeItems };
            });

            return updatedItems;
        });
    };
    const handleChangeAccountType = (selectedOption) => {
        setAccountType(selectedOption.value);
        setAddEditableItem((prevState) => ({
            ...prevState,
            paymentAcceptanceType: selectedOption ? selectedOption.value : ''
        }));
    };


    const setPaymentDate = async (date) => {
        // const response1 = await ClientService.CheckIfMonthClosed(client.caseId, date, token);
        // const isClosedReportingMonth = await response1.json();
        // if (isClosedReportingMonth) {
        //     toast.error(t('MonthReportAlreadyClosedTryAgain'));
        //     return
        // }
        setAddEditableItem((prevItem) => ({
            ...prevItem,
            date: date.toISOString()
        }));
    }
    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
        addEditableItem.description = event.target.value;
    };
    const handleChangeOriginalTaxClearance = (event) => {
        const raw = event.target.value.trim();      // always a string
        const normalised = raw === '' ? 0        // user cleared the field
            : Number(raw) // otherwise turn to number

        // Use the proper state update pattern
        handleAddEditableItemChange('withholdingTax', normalised);
        // setOriginalTaxClearance(value);
        

    };

    const handleRemoveItem = (type, index) => {
        let count = 0;

        // Update paymentAcceptanceItems
        const newItems = paymentAcceptanceItems.filter(item => {
            if (item.type === type) {
                if (count === index) {
                    count++;
                    return false;
                }
                count++;
            }
            return true;
        });
        setPaymentAcceptanceItems(newItems);

        // Update addEditableItem
        setAddEditableItem(prevItem => {
            const updatedTypeItems = prevItem[type].filter((_, idx) => idx !== index);
            return { ...prevItem, [type]: updatedTypeItems };
        });
    };

    const handleAddItem = (theType, suggestedAmount = '', accountFields = {}) => {
        const paymentType = addEditableItem.paymentAcceptanceType;

        const newItem = {
            type: theType,
            description: '',
            amount: suggestedAmount,
            paymentDate: new Date(),
            bankName: '',
            bankCode: '',
            bankBranchCode: '',
            supplierAccountNumber: '',
            bankTransactionsCode: Constants.PaymentAcceptanceConstantsAccountcards.GeneralBank,
            creditAccount: paymentType === 'תקבול' ? addEditableItem.accountCodeId || '' : '',
            debitAccount: paymentType === 'תשלום' ? addEditableItem.accountCodeId || '' : '',
            ...accountFields,
        };

        // Update paymentAcceptanceItems
        setPaymentAcceptanceItems(prevItems => [...prevItems, newItem]);

        // Update addEditableItem
        setAddEditableItem(prevItem => ({
            ...prevItem,
            [theType]: [...prevItem[theType], newItem]
        }));

    };
    useEffect(() => {
        let unionArray = [];
        if (addEditableItem) {
            unionArray = [
                ...(addEditableItem.checks || []),
                ...(addEditableItem.creditCards || []),
                ...(addEditableItem.cash || []),
                ...(addEditableItem.bankTransactions || [])
            ];
        }

        if (unionArray.length > 0) {
            const allAmountsFilled = unionArray.every(item => item.amount !== undefined && item.amount !== null && item.amount !== '');
            const allFieldsFilled = allAmountsFilled &&
                (addEditableItem.accountCaseId !== undefined && addEditableItem.accountCaseId !== null && addEditableItem.accountCaseId !== '' ||
                    addEditableItem.accountCodeId !== undefined && addEditableItem.accountCodeId !== null && addEditableItem.accountCodeId !== '' ||
                    addEditableItem.accountCodeName !== undefined && addEditableItem.accountCodeName !== null && addEditableItem.accountCodeName !== '') &&
                addEditableItem.paymentAcceptanceType !== undefined && addEditableItem.paymentAcceptanceType !== null && addEditableItem.accountType !== '';



            setButtonDisabled(!allFieldsFilled);
        } else {
            setButtonDisabled(true);
        }
    }, [addEditableItem, accountCodeId, accountType]);

    // inside HoldingItems.jsx
    const openPaymentAcceptanceModal = (row/* a check / credit-card / … row */) => {
        const pa = holdingItems?.paymentAcceptances
            ?.find(p => p.id === row.paymentAcceptanceId);

        if (!pa) return;                          // no parent → nothing to edit

        const paForModal = {
            ...pa,
            checks: pa.checks ?? [],
            creditCards: pa.creditCards ?? [],
            cash: pa.cash ?? [],
            bankTransactions: pa.bankTransactions ?? [],
            paymentAcceptanceType: pa.paymentAcceptanceType,
            docType: 'PaymentAcceptances'
        };

        setAddEditableItem(paForModal);               // reuse the same state you show in the modal
        setPalCode(paForModal.palCode || '');
        setStatusCheck(paForModal.status === 'done');
        setButtonDisabled(false);
        setPaymentModal(true);

    };

    const handleEdit = (item, index, isPopup = true) => {
        setEditingRow(item.id);
        const docType = item.paymentAcceptanceId ? 'PaymentAcceptances' : 'JournalEntries';
        item.docType = docType;
        const rowWithDocType = { ...item, docType };
        setCurrentIndex(index);
        setItemToDelete(rowWithDocType);

        if (item.paymentAcceptanceId) {
            // PaymentAcceptance row → open the dedicated PA modal only (skip generic EditModal)
            openPaymentAcceptanceModal(rowWithDocType);
            return;
        }

        // JournalEntries row → open the generic EditModal
        setEditedItem(rowWithDocType);
        const statusChecked = client.documentIds?.journalEntries?.includes(item.id);
        setStatusCheck(!statusChecked);
        setEditedPopupItem(isPopup);
    };

    const handleMuiChange = (event, value) => {
        if (value?.value1 === 'AddItem') {
            setAccountCodeName("");
            setAccountCodeId("");
            setCompanyId("");
            setAddNewAccountCardDocument(true);
            setAddNewAccountCard(true);
        }
        else {
            setItemEditing(true);
            const updatedFields = {
                accountCaseId: value.accountCaseId,
                accountCodeId: value.cardId,
                accountCodeName: value.name,
            };

            setAccountCodeName(value.name);
            setCompanyId(value.accountCaseId);
            setAccountCodeId(value.cardId);
            setInvoiceClientCaseId(value.cardId);

            // Update addEditableItem state
            setAddEditableItem(prevState => ({
                ...prevState,
                ...updatedFields,
            }));
            setSelectedOption({ ...value });

            // Call the function to update items
            updateAllItems(value, updatedFields);
        }
    };

    const updateAllItems = (value, updatedFields) => {
        const updatedItems = ['checks', 'bankTransactions', 'creditCards', 'cash'];
        const paymentType = addEditableItem.paymentAcceptanceType;
        updatedItems.forEach(itemType => {
            addEditableItem[itemType]?.forEach((item, index) => {
                // Determine the field to update
                const fieldToUpdate = paymentType === 'תקבול' ? 'creditAccount' : 'debitAccount';

                handleItemChange(itemType, index, fieldToUpdate, value.cardId);
            });
        });
        // Update addEditableItem with new account data
        setAddEditableItem(prevState => ({
            ...prevState,
            ...updatedFields,
        }));
    };

    const handleAccountEdit = (option) => {
        setShowAccountCardInputsEdit(true);
        setAccountCodeName(option.name);
        setAccountCodeId(option.cardId);
        setCompanyId(option.caseId);
        const account = accountCardOptions.find(account => account.cardId === option.cardId);
        setPalCode(account ? account.palCode : '');
        setOldSelectedAccountCardItem({
            cardId: option.cardId,
            caseId: option.caseId,
            accountCaseId: option.accountCaseId,
            name: option.name,
            palCode: '',
            client: null

        })
        setAddNewAccountCardDocument(true);
    };

    const handlePrevious = () => {
        let newIndex = currentIndex;

        while (newIndex > 0) {
            newIndex -= 1;
            const previousItem = getItemAtIndex(filteredAndSortedTransactions, newIndex);
            const currentItem = getItemAtIndex(filteredAndSortedTransactions, currentIndex);

            // Check if the previous item has a different id
            if (previousItem.id !== currentItem.id) {
                setCurrentItem(previousItem, newIndex);
                break;  // Exit the loop once a different ID is found
            }
        }
    };

    /* ↓ add near your other useState declarations in HoldingItems.jsx */
    const [sortConfigJE, setSortConfigJE] = useState({
        key: 'uploadDate',      // default sort field
        direction: 'descending',// or 'ascending'
        type: 'date'            // 'number' | 'string' | 'date'
    });


    const filteredAndSortedTransactions = useMemo(() => {
        if (!transactions || transactions.length === 0) {
            return [];
        }
        // Filtering the transactions based on searchQuery
        const filteredData = transactions.filter((transaction) => {
            const query = searchQuery.toLowerCase();
            return (
                transaction?.description?.toLowerCase().includes(query) ||
                transaction?.reference1?.toLowerCase().includes(query) ||
                transaction?.reference2?.toLowerCase().includes(query) ||
                transaction?.debitAccount?.toString().includes(query) ||
                transaction?.creditAccount?.toString().includes(query) ||
                transaction?.balance?.toString().includes(query) ||
                new Date(transaction.documentDate).toLocaleDateString().includes(query) ||
                new Date(transaction.uploadDate).toLocaleDateString().includes(query)
            );
        });

        // Sorting the filtered transactions based on sortConfig
        if (sortConfig.key) {
            filteredData.sort((a, b) => {
                const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined

                if (sortConfig.type === 'number') {
                    return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                } else if (sortConfig.type === 'date') {
                    return sortConfig.direction === 'ascending'
                        ? new Date(aValue) - new Date(bValue)
                        : new Date(bValue) - new Date(aValue);
                } else { // default to string comparison
                    return sortConfig.direction === 'ascending'
                        ? aValue?.localeCompare(bValue)
                        : bValue?.localeCompare(aValue);
                }
            });
        }
        const updatedDataForPdf = {
            ...dataForPdf,
            transactions: filteredData,
        };

        return filteredData;
    }, [transactions, searchQuery, sortConfig]);

    const filteredAndSortedData = useMemo(() => {
        const src = depositJournalEntryData;                       // rows to filter / sort
        if (!src || src.length === 0) return [];

        /* ----- filter the same way JournalEntry.jsx does ----- */
        const filtered = src.filter(r => {
            const q = searchQuery.toLowerCase();
            return (
                (r.accountCodeName || '').toLowerCase().includes(q) ||
                (r.reference || '').includes(q) ||
                (r.sortCodeId || '').toString().includes(q) ||
                (r.description || '').toLowerCase().includes(q) ||
                (r.uploadNumber || '').toString().includes(q) ||
                formatDateNew(r.documentDate).includes(q)
            );
        });

        /* ----- sort ----- */
        const { key, direction, type } = sortConfigJE;
        if (key) {
            filtered.sort((a, b) => {
                const av = a[key] ?? '';
                const bv = b[key] ?? '';
                if (type === 'number') {
                    return direction === 'ascending' ? av - bv : bv - av;
                }
                if (type === 'date') {
                    return direction === 'ascending'
                        ? new Date(av) - new Date(bv)
                        : new Date(bv) - new Date(av);
                }
                /* string */
                return direction === 'ascending'
                    ? av.toString().localeCompare(bv)
                    : bv.toString().localeCompare(av);
            });
        }
        return filtered;
    }, [depositJournalEntryData, searchQuery, sortConfigJE]);


    const [currentIndex, setCurrentIndex] = useState(-1);

    const handleNext = () => {
        let newIndex = currentIndex;

        while (newIndex < filteredAndSortedTransactions.length - 1) {
            newIndex += 1;
            const nextItem = getItemAtIndex(filteredAndSortedTransactions, newIndex);
            const currentItem = getItemAtIndex(filteredAndSortedTransactions, currentIndex);
            // Check if the next item has a different id
            if (nextItem.id !== currentItem.id) {
                setCurrentItem(nextItem, newIndex);
                break;  // Exit the loop once a different ID is found
            }
        }
    };

    const handleAccountDelete = (option) => {
        setActionType('deleteAccountCard');
        setAccountCardIdToDelete(option.cardId);
        setIsModalVisible(true);
        // handleAccountCardDeleteClick(option.cardId);
    };

    const handleClose = async (clearDocuments = true) => {
        setOpenInvoiceCreatorModal(false);
        setPaymentModal(false);
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            offsets: [],
            date: new Date()
        });
    }
    const [paymentModal, setPaymentModal] = useState(false);


    const setCurrentItem = async (transaction, rowIndex) => {
        try {


            let type = transaction.type1
            let myItem;
            // Check if transactionDetailsDictionary has the item with the transaction ID
            if (transactionDetailsDictionary[transaction.id]) {
                myItem = transactionDetailsDictionary[transaction.id];
            } else {
                // If not, make an API call to fetch the item
                let response;
                if (transaction.type1 === 'JournalEntries') {
                    response = await DocumentService.GetDocumentById('JournalEntries', client.caseId, transaction.id, token);
                    type = transaction.type1;
                } else {
                    response = await DocumentService.GetDocumentById(type, client.caseId, transaction.id, token);
                }

                if (response.ok) {
                    myItem = await response.json();
                    myItem.docType = type;

                    let statusChecked = false;

                    if (type === "Incomes") {
                        statusChecked = client.documentIds.incomes.includes(myItem.id);
                    } else if (type === "JournalEntries") {
                        statusChecked = client.documentIds.journalEntries.includes(myItem.id);
                    } else if (type === "Expenses") {
                        statusChecked = client.documentIds.expenses.includes(myItem.id);
                    } else {
                        statusChecked = client.documentIds.checks.includes(myItem.id);
                    }

                    setStatusCheck(!statusChecked);
                    // Store the fetched item in transactionDetailsDictionary with the transaction ID as key
                    const updatedDictionary = { ...transactionDetailsDictionary };
                    updatedDictionary[transaction.id] = myItem;
                    setTransactionDetailsDictionary(updatedDictionary);
                } else {
                    console.error('Error fetching document details');
                    return; // Exit the function if the API call fails
                }
            }

            // Load the previous and next items asynchronously without await
            loadSurroundingItems(rowIndex, type, filteredAndSortedTransactions);
            if (!type.includes("PaymentAcceptances")) {
                if (transaction.type1 !== 'JournalEntries') {
                    setCurrentIndex(rowIndex);
                    setItemToDelete({ id: myItem.id, type: myItem.docType });
                    setEditedItem({ ...myItem });
                    setEditedPopupItem(true);
                    setEditedJournalItem(false);
                    setPaymentModal(false);
                } else {

                    setCurrentIndex(rowIndex);
                    setItemToDelete({ id: myItem.id, type: myItem.docType });
                    setEditedItem({ ...myItem });
                    setEditedPopupItem(true);
                    setEditedJournalItem(true);
                    setPaymentModal(false);
                }
            }
            else {
                // Extract the type and id from the transaction
                const itemType = transaction.paymentAcceptanceFinancialTransactionAccountDetailsItem.type;
                const itemId = transaction.paymentAcceptanceFinancialTransactionAccountDetailsItem.id;

                // Get the array from myItem corresponding to the type
                const itemsArray = myItem[itemType]; // e.g., myItem['checks']


                // Ensure itemsArray exists and is an array
                if (Array.isArray(itemsArray)) {
                    // Find the index of the item with the matching id
                    const indexInArray = itemsArray.findIndex(item => item.id === itemId);


                    setShowType({ type: itemType, index: indexInArray })

                } else {
                    console.error(`No array found for type "${itemType}" in myItem.`);
                    setShowType({ type: itemType, index: -1 })

                }

                setItemToDelete({ id: myItem.id, type: myItem.docType });
                setCurrentIndex(rowIndex);
                setOpenInvoiceCreatorModal(true);
                setAddEditableItem({ ...myItem });
                setPaymentModal(true);
                setEditedJournalItem(false);
                setEditedPopupItem(false);
                setItemEditing(true);
            }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };

    // Function to load the surrounding items (previous and next)
    const loadSurroundingItems = (rowIndex, type, transactionArray) => {
        return new Promise((resolve, reject) => {
            const updatedDictionary = { ...transactionDetailsDictionary };
            const promises = [];

            // Load the previous transaction if it exists and is not already loaded
            if (rowIndex > 0 && !transactionDetailsDictionary[transactionArray[rowIndex - 1].id]) {
                const previousPromise = DocumentService.GetDocumentById(transactionArray[rowIndex - 1].type, client.caseId, transactionArray[rowIndex - 1].id, token)
                    .then(response => response.ok ? response.json() : null)
                    .then(data => {
                        if (data) {
                            data.docType = transactionArray[rowIndex - 1].type;
                            updatedDictionary[transactionArray[rowIndex - 1].id] = data;
                            setTransactionDetailsDictionary(updatedDictionary);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching previous transaction:', error);
                        reject(error);
                    });

                promises.push(previousPromise);
            }

            // Load the next transaction if it exists and is not already loaded
            if (rowIndex < transactionArray.length - 1 && !transactionDetailsDictionary[transactionArray[rowIndex + 1].id]) {
                const nextPromise = DocumentService.GetDocumentById(transactionArray[rowIndex + 1].type, client.caseId, transactionArray[rowIndex + 1].id, token)
                    .then(response => response.ok ? response.json() : null)
                    .then(data => {
                        if (data) {
                            data.docType = transactionArray[rowIndex + 1].type;
                            updatedDictionary[transactionArray[rowIndex + 1].id] = data;
                            setTransactionDetailsDictionary(updatedDictionary);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching next transaction:', error);
                        reject(error);
                    });

                promises.push(nextPromise);
            }

            // Resolve when all promises are complete
            Promise.all(promises).then(() => resolve()).catch(error => reject(error));
        });
    };

    const getItemAtIndex = (transactions, newIndex) => {
        // Convert the object to an array of its values
        const transactionsArray = Object.values(transactions);

        // Check if the index is within the bounds of the array
        if (newIndex >= 0 && newIndex < transactionsArray.length) {
            return transactionsArray[newIndex];
        } else {
            console.error('Index out of bounds');
            return null;
        }
    };

    const [dataForPdf, setDataForPdf] = useState(null);

    const [transactionDetailsDictionary, setTransactionDetailsDictionary] = useState({});


    const [palCodeDetails, setPalCodeDetails] = useState('');


    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <button className={`document-custom-input document-custom-input-range `} onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const handleGoBack = () => {

        if (client) {

            // handleBack();
            goBack();
        }
    };
    const [palCodeName, setPalCodeName] = useState(null);
    const [accountCardName, setAccountCardName] = useState(null);
    const [accountCardId, setAccountCardId] = useState(null);

    const fetchUserData = async () => {
        setLoading(true);
        try {
            const currentUser = await UserService.getCurrentUser();
            const currentToken = await UserService.getCurrentToken();

            if (currentUser && currentToken) {
                setUser(currentUser);
                setToken(currentToken);

                if (location.state && location.state.client) {
                    setType("HoldingItems");
                    setClient(location.state.client);
                    await fetchEnums(currentUser, currentToken, location.state.client);
                }
            }
            else {
                navigate("/login");
            }

        } catch (error) {
            console.error("Error fetching user data:", error);
            // navigate("/login");
        }
        setLoading(false);
    };
    useEffect(() => {
        fetchUserData();
    }, [location]);

    const handleDeleteClick = () => {
        setIsModalVisible(true);
    };

    const handleEditDeleteClick = (itemId) => {
        setEditedPopupItem(false);
        setEditedItem({});
        setPaymentModal(false);
        setAddEditableItem({
            checks: [],
            creditCards: [],
            cash: [],
            bankTransactions: [],
            offsets: [],
            date: new Date()
        });
        handleDeleteClick();
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLoading(true);


        setIsModalVisible(false);
        try {
            const response = await DocumentService.DeleteDocument(itemToDelete.docType, itemToDelete.id, token);
            if (response.ok) {
                const finalEndDate = endDate instanceof Date && !isNaN(endDate)
                    ? endDate
                    : new Date(Date.UTC(startDate.getFullYear(), 11, 31));
                setEndDate(finalEndDate);

                // Show success toast
                toast.success(t("documentDeleteSuccess"));
                await fetchEnums(user, token, client, startDate, endDate, holdingItemType);
            } else {
                // Handle any errors or display an error toast
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);

                // Show error toast
                toast.error(t("documentDeleteError"));
                await fetchEnums(user, token, client, startDate, endDate, holdingItemType);
            }
        } catch (error) {
            console.error('Error deleting document:', error);
            await fetchEnums(user, token, client, startDate, endDate, holdingItemType);
            // Show error toast
            toast.error(t("documentDeleteError"));
        }
        setLoading(false);
    };

    const closeDepositPdf = () => {
        setDepositPdfVisible(false);
        setDepositPdfBlob(null);
    };

    /* flatten all transactions (checks / cash / credit / bank) with parent PA id */
    const flattenHoldingRows = () => {
        const rowsFlat = [];
        (holdingItems?.paymentAcceptances || []).forEach(pa => {
            const push = (arr = [], type) =>
                arr?.forEach(tr =>
                    rowsFlat.push({
                        ...tr,
                        _type: type,
                        paymentAcceptanceId: pa.id,
                    }),
                );

            push(pa.checks, 'Check');
            push(pa.cash, 'Cash');
            push(pa.creditCards, 'CreditCard');
            push(pa.bankTransactions, 'BankTransfer');
        });
        return rowsFlat;
    };

    const openDepositOptions = () => {
        if (selectedIds.length === 0 || !depositAccountCard) return;
        const rowsFlat = flattenHoldingRows();
        const selectedRows = rowsFlat.filter(r => selectedIds.includes(r.id));
        setDepositSelectedRows(selectedRows);
        setDepositItemAmounts(
            selectedRows.reduce((acc, r) => ({ ...acc, [r.id]: '' }), {}),
        );
        setDepositCustomDate(new Date());
        setDepositDescription('');
        setOneDepositPerCheck(true);
        setDepositOptionsOpen(true);
    };

    const closeDepositOptions = () => {
        setDepositOptionsOpen(false);
    };

    const handleItemAmountChange = (id, val, maxAllowed = null) => {
        const raw = String(val ?? '');
        if (raw.trim() === '') {
            setDepositItemAmounts(prev => ({ ...prev, [id]: '' }));
            return;
        }

        const parsed = parseFloat(raw);
        if (!Number.isFinite(parsed)) {
            setDepositItemAmounts(prev => ({ ...prev, [id]: raw }));
            return;
        }

        let clamped = parsed;
        if (clamped < 0) clamped = 0;
        if (maxAllowed !== null && maxAllowed !== undefined && Number.isFinite(maxAllowed)) {
            if (clamped > maxAllowed) clamped = maxAllowed;
        }

        setDepositItemAmounts(prev => ({ ...prev, [id]: String(clamped) }));
    };

    const resolveItemAmount = (row) => {
        const raw = depositItemAmounts[row.id];
        if (raw === undefined || raw === null || String(raw).trim() === '') {
            return (row.remainingAmount ?? row.amount) || 0;
        }
        const parsed = parseFloat(raw);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : ((row.remainingAmount ?? row.amount) || 0);
    };

    // Derive Original / Already-deposited / Remaining for the dialog table.
    // The backend already returns `remainingAmount` (and `depositedSoFar` when present);
    // we only fall back to the math when those fields are missing.
    const getRowDepositBreakdown = (row) => {
        const original = Number(row.originalAmount ?? row.amount) || 0;
        const deposited = Number(row.depositedSoFar) || 0;
        const remaining = Number.isFinite(row.remainingAmount)
            ? row.remainingAmount
            : Math.max(0, original - deposited);
        return { original, deposited, remaining, isPartial: deposited > 0 };
    };

    const depositOverrideTotal = useMemo(
        () => depositSelectedRows.reduce((sum, r) => sum + resolveItemAmount(r), 0),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [depositSelectedRows, depositItemAmounts],
    );

    const handleConfirmDepositOptions = async () => {
        if (generatingDraft) return;          // guard against double‑click

        // UI guard: don't allow custom amount > remaining/original amount
        const invalid = (depositSelectedRows || []).find(r => {
            const maxAllowed = (r.remainingAmount ?? r.amount) || 0;
            const raw = depositItemAmounts[r.id];
            if (raw === undefined || raw === null || String(raw).trim() === '') return false;
            const parsed = parseFloat(raw);
            return Number.isFinite(parsed) && parsed > maxAllowed;
        });

        if (invalid) {
            toast.error(t('CustomAmountTooHigh') || 'Custom amount cannot be bigger than amount');
            return;
        }

        // Keep the dialog open so the user sees the loading indicator on the button.
        // handleGenerateDraft will close it once the draft PDF is ready.
        await handleGenerateDraft();
    };

    const [pdfIsDraft, setPdfIsDraft] = useState(true);

    const handleGenerateDraft = async () => {
        if (generatingDraft) return;          // guard against double‑click

        setGeneratingDraft(true);
        try {
            if (selectedIds.length === 0) return;

            /* ───── flatten exactly like the table now does ───── */
            const rowsFlat = [];
            (holdingItems.paymentAcceptances || []).forEach(pa => {
                const push = (arr = [], type) =>
                    arr.forEach(tr =>
                        rowsFlat.push({
                            ...tr,
                            _type: type,                // Check | Cash | CreditCard | BankTransfer
                            paymentAcceptanceId: pa.id  // parent id
                        })
                    );

                push(pa.checks, 'Check');
                push(pa.cash, 'Cash');
                push(pa.creditCards, 'CreditCard');
                push(pa.bankTransactions, 'BankTransfer');
            });

            const selectedRows = rowsFlat.filter(r => selectedIds.includes(r.id));
            if (selectedRows.length === 0) return;

            const noteText = (depositDescription || '').trim();
            const itemsDTO = selectedRows.map(r => {
                const raw = depositItemAmounts[r.id];
                const parsed = raw !== undefined && raw !== null && String(raw).trim() !== ''
                    ? parseFloat(raw)
                    : NaN;
                const amountOverride = Number.isFinite(parsed) && parsed > 0 ? parsed : null;
                return {
                    paymentAcceptanceId: r.paymentAcceptanceId,
                    transactionId: r.id,
                    note: noteText,
                    amount: amountOverride,
                };
            });

            const accountCardId =
                (depositAccountCard ? depositAccountCard.cardId : null) ||
                selectedRows[0].creditAccount ||
                selectedRows[0].debitAccount ||
                '0';

            const generateDateIso = depositCustomDate
                ? new Date(depositCustomDate).toISOString()
                : new Date().toISOString();

            const paymentTypeInt = parseInt(holdingItemType, 10);

            // Per-check draft only applies to Check holding type AND when >1 row was selected
            // AND the user opted in via the toggle.
            const useOnePerCheckDraft =
                oneDepositPerCheck &&
                paymentTypeInt === 1 &&
                selectedRows.length > 1;

            const res = useOnePerCheckDraft
                ? await DocumentService.GenerateDepositDocumentsPerCheckDraft(
                    client.caseId,
                    accountCardId,
                    generateDateIso,
                    paymentTypeInt,
                    itemsDTO,
                    token,
                    noteText || null,
                )
                : await DocumentService.GenerateDepositDocumentDraft(
                    client.caseId,
                    accountCardId,
                    generateDateIso,
                    paymentTypeInt,
                    itemsDTO,
                    token,
                    noteText || null,
                );

            toast.success(t('DepositDraftCreated'));

            /* open returned PDF */
            const bytes = Uint8Array.from(atob(res.pdfBase64), c => c.charCodeAt(0));
            setDepositPdfBlob(new Blob([bytes], { type: 'application/pdf' }));
            setPdfIsDraft(true);
            setDepositPdfVisible(true);
            setDepositOptionsOpen(false);
        } catch (err) {
            toast.error(err.message || t('DepositDraftFailed'));
        } finally {
            setGeneratingDraft(false);
        }
    };


    const handleGenerateDepositDocument = async () => {
        if (creatingDepositDoc) return;       // guard against double‑click
        try {
            setCreatingDepositDoc(true);

            /* ---- 1) flatten all rows exactly like the draft does ---- */
            const rowsFlat = [];
            (holdingItems.paymentAcceptances || []).forEach(pa => {
                const push = (arr = [], type) =>
                    arr?.forEach(tr =>
                        rowsFlat.push({ ...tr, _type: type, paymentAcceptanceId: pa.id })
                    );

                push(pa.checks, 'Check');
                push(pa.cash, 'Cash');
                push(pa.creditCards, 'CreditCard');
                push(pa.bankTransactions, 'BankTransfer');
            });

            const selectedRows = rowsFlat.filter(r => selectedIds.includes(r.id));
            if (selectedRows.length === 0) {
                toast.info(t('NoRowsSelected'));
                return;
            }

            /* ---- 2) helpers shared by both modes ---- */
            const noteText = (depositDescription || '').trim();
            const accountCardId =
                (depositAccountCard ? depositAccountCard.cardId : null) ||
                selectedRows[0].creditAccount ||
                selectedRows[0].debitAccount ||
                '0';
            const generateDateIso = depositCustomDate
                ? new Date(depositCustomDate).toISOString()
                : new Date().toISOString();
            const paymentTypeInt = parseInt(holdingItemType, 10);

            const buildItemDTO = (r) => {
                const raw = depositItemAmounts[r.id];
                const parsed = raw !== undefined && raw !== null && String(raw).trim() !== ''
                    ? parseFloat(raw)
                    : NaN;
                const amountOverride = Number.isFinite(parsed) && parsed > 0 ? parsed : null;
                return {
                    paymentAcceptanceId: r.paymentAcceptanceId,
                    transactionId: r.id,
                    note: noteText,
                    amount: amountOverride,
                };
            };

            // Per-check mode only applies to Check holding type and when >1 row was selected.
            const useOnePerCheck =
                oneDepositPerCheck &&
                paymentTypeInt === 1 &&
                selectedRows.length > 1;

            if (useOnePerCheck) {
                /* ---- per-check mode: one server round-trip → server creates one
                       deposit + one journal entry per check and returns either a
                       single PDF (if only 1 check) or a ZIP archive (if >1) ---- */
                const itemsDTO = selectedRows.map(buildItemDTO);

                const result = await DocumentService.GenerateDepositDocumentsPerCheck(
                    client.caseId,
                    accountCardId,
                    generateDateIso,
                    paymentTypeInt,
                    itemsDTO,
                    token,
                    noteText || null,
                );

                saveAs(result.blob, result.fileName);

                // ZIP can't be previewed in an <iframe>, so only swap the preview
                // when the server returned a single PDF.
                if (!result.isZip) {
                    setDepositPdfBlob(result.blob);
                    setPdfIsDraft(false);
                    setDepositPdfVisible(true);
                } else {
                    setDepositPdfVisible(false);
                    setDepositPdfBlob(null);
                }

                if (result.errors) {
                    toast.warn(
                        `${t('DepositDocumentCreated')} (${result.count}/${result.requested}) — ${result.errors}`,
                    );
                } else {
                    toast.success(
                        `${t('DepositDocumentCreated')} (${result.count}/${result.requested || selectedRows.length})`,
                    );
                }
            } else {
                /* ---- combined mode: one deposit + one journal entry for all selected ---- */
                const itemsDTO = selectedRows.map(buildItemDTO);

                const pdfBlob = await DocumentService.GenerateDepositDocument(
                    client.caseId,
                    accountCardId,
                    generateDateIso,
                    paymentTypeInt,
                    itemsDTO,
                    token,
                    noteText || null,
                );

                saveAs(pdfBlob, `Deposit-${client.caseId}.pdf`);

                setDepositPdfBlob(pdfBlob);
                setPdfIsDraft(false);
                setDepositPdfVisible(true);

                toast.success(t('DepositDocumentCreated'));
            }

            /* ---- housekeeping ---- */
            await fetchEnums(user, token, client, startDate, endDate, holdingItemType);
            setSelectedIds([]);
        } catch (err) {
            console.error(err);
            toast.error(err.message || t('DepositDocumentFailed'));
        }
        setCreatingDepositDoc(false);
    };

    return (
        <>
            <DraggableModal
                bigIframeModalOpen={bigIframeModalOpen}
                openedIframeUrl={openedIframeUrl}
                handleCloseIframeModal={handleCloseIframeModal}
            />

            <Dialog
                open={depositOptionsOpen}
                onClose={(_e, reason) => {
                    // Don't let the user dismiss the dialog while a draft is being generated.
                    if (generatingDraft) return;
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return closeDepositOptions();
                    closeDepositOptions();
                }}
                fullWidth
                maxWidth="md"
                dir={direction}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {t('GenerateDepositDraft')}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                            <Box sx={{ minWidth: 220 }}>
                                <CustomDatePicker
                                    date={depositCustomDate}
                                    onDateChange={(d) => setDepositCustomDate(d)}
                                    label={t('PaymentDate')}
                                />
                            </Box>
                            <TextField
                                label={t('Description')}
                                value={depositDescription}
                                onChange={(e) => setDepositDescription(e.target.value)}
                                multiline
                                minRows={2}
                                sx={{ flex: 1, minWidth: 260 }}
                                variant="outlined"
                                inputProps={{ dir: direction }}
                            />
                        </Box>

                        {parseInt(holdingItemType, 10) === 1 && depositSelectedRows.length > 1 && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            color="primary"
                                            checked={oneDepositPerCheck}
                                            onChange={(e) => setOneDepositPerCheck(e.target.checked)}
                                        />
                                    }
                                    label={t('OneDepositPerCheck')}
                                />
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    {oneDepositPerCheck
                                        ? t('OneDepositPerCheckHint')
                                        : t('OneDepositForAllChecksHint')}
                                </Typography>
                            </Box>
                        )}

                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('Description')}</TableCell>
                                        <TableCell align="right">{t('Original')}</TableCell>
                                        <TableCell align="right">{t('AlreadyDeposited')}</TableCell>
                                        <TableCell align="right">{t('Remaining')}</TableCell>
                                        <TableCell align="right" sx={{ minWidth: 160 }}>
                                            {t('CustomAmount') || t('Amount')}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {depositSelectedRows.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">
                                                {t('NoRowsSelected')}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {depositSelectedRows.map(row => {
                                        const { original, deposited, remaining, isPartial } =
                                            getRowDepositBreakdown(row);
                                        return (
                                            <TableRow key={row.id}>
                                                <TableCell>
                                                    {row.description || row._type}
                                                </TableCell>
                                                <TableCell align="right">
                                                    ₪ {beautifyNumber(original)}
                                                </TableCell>
                                                <TableCell
                                                    align="right"
                                                    sx={{ color: isPartial ? 'warning.main' : 'text.disabled' }}
                                                >
                                                    {isPartial ? `₪ ${beautifyNumber(deposited)}` : '—'}
                                                </TableCell>
                                                <TableCell
                                                    align="right"
                                                    sx={{ fontWeight: isPartial ? 600 : 400 }}
                                                >
                                                    ₪ {beautifyNumber(remaining)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <TextField
                                                        value={depositItemAmounts[row.id] ?? ''}
                                                        onChange={(e) =>
                                                            handleItemAmountChange(
                                                                row.id,
                                                                e.target.value,
                                                                remaining,
                                                            )
                                                        }
                                                        type="number"
                                                        size="small"
                                                        placeholder={String(remaining)}
                                                        variant="outlined"
                                                        inputProps={{
                                                            dir: direction,
                                                            step: '0.01',
                                                            min: 0,
                                                            max: remaining,
                                                            style: { textAlign: 'right' },
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Typography sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
                                <span style={{ fontWeight: 400 }}>{t('TotalWithdrawalAmount')}:</span>
                                &nbsp;₪ {beautifyNumber(depositOverrideTotal)}
                            </Typography>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={closeDepositOptions}
                        color="inherit"
                        disabled={generatingDraft}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button
                        onClick={handleConfirmDepositOptions}
                        variant="contained"
                        disabled={generatingDraft}
                        startIcon={
                            generatingDraft
                                ? <CircularProgress size={16} color="inherit" />
                                : null
                        }
                        sx={{ fontWeight: 600, textTransform: 'none' }}
                    >
                        {generatingDraft
                            ? (t('Generating') ? `${t('Generating')}…` : t('GenerateDepositDraft'))
                            : t('GenerateDepositDraft')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Modal
                open={depositPdfVisible}
                onClose={closeDepositPdf}
                aria-labelledby="deposit-draft-modal-title"
                aria-describedby="deposit-draft-modal-description"
            >
                <div className="draft-pdf-modal-container">
                    {depositPdfBlob && (
                        <iframe
                            src={URL.createObjectURL(depositPdfBlob)}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                            aria-label="Deposit PDF preview"
                        />
                    )}

                    <div className="draft-pdf-button-container">
                        {/* show ONLY while it’s a draft */}
                        {pdfIsDraft && (
                            <button
                                className="create-invoice-button"
                                onClick={handleGenerateDepositDocument}
                                disabled={creatingDepositDoc}
                            >
                                {creatingDepositDoc ? t('Generating') + '…' : t('GenerateDepositDocument')}
                            </button>
                        )}

                        <button className="close-invoice-button" onClick={closeDepositPdf}>
                            {t('close')}
                        </button>
                    </div>
                </div>
            </Modal>


            {(addEditableItem && paymentModal) && (
                <PaymentAcceptanceCreateEditModal
                    openInvoiceCreatorModal={openInvoiceCreatorModal}
                    handleClose={handleClose}
                    t={t}
                    itemEditing={itemEditing}
                    addNewAccountCardDocument={addNewAccountCardDocument}
                    companyId={companyId}
                    accountCodeName={accountCodeName}
                    accountCodeId={accountCodeId}
                    setAccount={setAccount}
                    Constants={Constants}
                    palCode={palCode}
                    setPalCode={setPalCode}
                    isRange={isRange}
                    addEditableItem={addEditableItem}  // renamed from editedItem
                    isClosedReportingMonth={isClosedReportingMonth}
                    handleSaveEditAccountCard={handleSaveEditAccountCard}
                    handleAddAccountCard={handleAddAccountCard}
                    handleCloseAddNewAccountCardDocument={handleCloseAddNewAccountCardDocument}
                    accountCardOptions={accountCardOptions}
                    selectedOption={selectedOption}
                    handleMuiChange={handleMuiChange}
                    handleEdit={handleEdit}
                    handleAccountDelete={handleAccountDelete}  // renamed from handleDelete
                    handleChangeAccountType={handleChangeAccountType}
                    customStyles={customStyles}
                    setPaymentDate={setPaymentDate}
                    setReportingMonthDate={setReportingMonthDate}
                    handleDescriptionChange={handleDescriptionChange}
                    handleChangeOriginalTaxClearance={handleChangeOriginalTaxClearance}
                    handleAddEditableItemChange={handleAddEditableItemChange}
                    handleItemChange={handleItemChange}
                    handleRemoveItem={handleRemoveItem}
                    showAccountCardInputsEdit={showAccountCardInputsEdit}
                    statusCheck={statusCheck}
                    handleRadioChange={handleRadioPAChange}
                    handleSave={handleSave}
                    buttonDisabled={buttonDisabled}
                    paymentBeingEdited={paymentBeingEdited}
                    CustomDropdown={CustomDropdown}
                    type={type}
                    direction={direction}
                    setAddNewAccountCardDocument={setAddNewAccountCardDocument}
                    fetchEnums={fetchEnums}
                    isClosedReportingMonthAndIsRange={isClosedReportingMonthAndIsRange}
                    handleAddItem={handleAddItem}
                    CustomPalCode={CustomPalCode}
                    handleAccountEdit={handleAccountEdit}
                    handlePrevious={handlePrevious}
                    currentIndex={currentIndex}
                    filteredAndSortedData={filteredAndSortedTransactions}
                    handleNext={handleNext}
                    showType={showType}
                    handleDeleteClick={handleEditDeleteClick}
                    haveNextAndPrevuios={false}
                    client={client}
                    token={token}
                    setLoading={setLoading}
                    handleTransferRefresh={onRefresh}
                />
            )}

            <>
                <>


                    <div className={`searchFilter-bar__container document-toolbar-row ${direction}`} style={{ marginTop: '10px' }}>
                        <Box className="document-filter-row" dir={direction}>
                            {isMonthly && (
                                <div className={headerStyles.dateSelectRange}>
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={startDate}
                                            month={startDate}
                                            onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                            labelYear={t('StartYear')}
                                            labelMonth={t('StartMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={endDate}
                                            month={endDate}
                                            onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                            labelYear={t('EndYear')}
                                            labelMonth={t('EndMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* Holding-item type selector */}
                            <div style={{ width: 200, '--filter-input': '#f5f5f6' }}>
                                <AutocompleteSelectFilter
                                    options={holdingTypeSelectOptions}
                                    selectedValues={
                                        holdingTypeSelectOptions.find(
                                            (o) => String(o.value) === String(holdingItemType)
                                        ) || null
                                    }
                                    onChange={(event, newValue) => handleHoldingTypeChange(newValue?.value)}
                                    label={t('PaymentType')}
                                    placeholder={t('PaymentType')}
                                    isMultiple={false}
                                    direction={direction}
                                    portalMenu
                                    searchable
                                />
                            </div>

                            {/* Fetch-type tab */}
                            <ToggleButtonGroup
                                value={fetchType}
                                exclusive
                                onChange={handleFetchTypeChange}
                                aria-label="Platform"
                                sx={{
                                    border: '2px solid #e5e7f6',
                                    borderRadius: '10px',
                                    backgroundColor: '#ffffff',
                                    p: '2px',
                                    gap: '2px',
                                    '& .MuiToggleButton-root': {
                                        width: 170,
                                        height: 36,
                                        border: 'none',
                                        borderRadius: '8px !important',
                                        textTransform: 'none',
                                        fontSize: 14,
                                        fontWeight: 700,
                                        color: '#666666',
                                        '&:hover': { backgroundColor: '#eef1ff' },
                                        '&.Mui-selected': {
                                            backgroundColor: '#304FFF',
                                            color: '#ffffff',
                                            '&:hover': { backgroundColor: '#2639db' },
                                        },
                                    },
                                }}
                            >
                                <ToggleButton value="HoldingItems">{t('HoldingItems')}</ToggleButton>
                                <ToggleButton value="DepositJournalEntries">{t('DepositJournalEntries')}</ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </div>
                    {fetchType === 'HoldingItems' ? (
                        <HoldingItemsTable
                            holdingItems={holdingItems}
                            handleEdit={handleEdit}
                            handleSortChange={(key, type = 'string') =>
                                setSortConfig(prev => ({
                                    key,
                                    type,
                                    direction: prev.direction === 'ascending' ? 'descending' : 'ascending'
                                }))
                            }
                            formatDateNew={formatDateNew}
                            paymentType={holdingItemType}
                            onSelectionChange={setSelectedIds}
                            accountCardOptions={accountCardOptions}
                        />
                    ) : fetchType === 'DepositJournalEntries' ? (
                        <JournalEntryDataGrid
                            ref={dataGridRef}
                            t={t}
                            client={client}
                            data={filteredAndSortedData}
                            isRange={isRange}
                            isClosedReportingMonth={false}
                            subAccountantOptions={subAccountantOptions}
                            accountCardOptions={accountCardOptions}
                            creditAccountOptions={creditAccountOptions}
                            debitAccountOptions={debitAccountOptions}
                            sortCodeIdOptions={sortCodeIdOptions}
                            formatDateNew={formatDateNew}
                            formatMonthYearDate={formatMonthYearDate}
                            beautifyNumber={beautifyNumber}
                            Constants={Constants}
                            handleDeleteClick={handleDeleteClick}
                            handleSave={handleSave}
                            handleCancel={handleCancel}
                            direction={direction}
                            setEditedItem={setEditedItem}
                            editedItem={editedItem}
                            setEditedPopupItem={setEditedPopupItem}
                            handleEdit={handleEdit}
                            setCurrentRowData={setCurrentRowData}
                            setOpenInlineEditModal={setOpenInlineEditModal}
                            handleSelectRows={handleSelectRows}
                            addNewJournalEntry={addNewJournalEntry}
                            setAddNewJournalEntry={setAddNewJournalEntry}
                            openPdfInNewTab={openPdfInNewTab}
                            handleOpenDialog={handleOpenDialog}
                            handleRightClickAction={handleRightClickAction}
                            complexDepositsChecked={complexDepositsChecked}
                            setDebitCreditSum={setDebitCreditSum}
                            showSearch={true}
                            isDepositTable={true}
                            /* forward sort change from grid to our state */
                            onSortModelChange={(model) => {
                                if (!model || model.length === 0) return;
                                const { field, sort } = model[0];
                                setSortConfigJE({
                                    key: field,
                                    direction: sort === 'asc' ? 'ascending' : 'descending',
                                    type: field === 'uploadDate' || field === 'documentDate' ? 'date' :
                                        field === 'amount' || field === 'uploadNumber' ? 'number' : 'string'
                                });
                            }}
                        />
                    ) : null}
                    {fetchType === 'HoldingItems' && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, marginTop: 2, flexWrap: 'wrap' }}>
                            {/* total chip */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    gap: 1,
                                    height: 40,
                                    px: 1.5,
                                    borderRadius: '12px',
                                    backgroundColor: '#f5f6fd',
                                    border: '2px solid #e5e7f6',
                                }}
                            >
                                <Typography sx={{ fontSize: '1.25rem', fontWeight: 700, color: '#304FFF', alignSelf: 'center' }}>
                                    ₪ {beautifyNumber(selectedAmount)}
                                </Typography>
                                <Typography sx={{ fontSize: '0.95rem', fontWeight: 500, color: '#666', alignSelf: 'center' }}>
                                    {t('TotalWithdrawalAmount')}:
                                </Typography>
                            </Box>

                            {/* choose target account-card */}
                            <div style={{ width: 220, '--filter-input': '#f5f5f6' }}>
                                <AutocompleteSelectFilter
                                    options={formattedAccountCardOptions}
                                    selectedValues={depositAccountCard}
                                    onChange={(e, v) => setDepositAccountCard(v)}
                                    label={t('Debit Account')}
                                    placeholder={t('Debit Account')}
                                    isMultiple={false}
                                    direction={direction}
                                    portalMenu
                                    searchable
                                />
                            </div>

                            {/* generate button */}
                            <Button
                                variant="contained"
                                sx={{
                                    height: 40,
                                    px: 4,
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    borderRadius: '12px',
                                    backgroundColor: '#304FFF',
                                    boxShadow: '0 6px 20px rgba(48,79,255,0.3)',
                                    '&:hover': { backgroundColor: '#2639db' },
                                    '&.Mui-disabled': { backgroundColor: '#c9d0ff', color: '#ffffff' },
                                }}
                                disabled={selectedIds.length === 0 || !depositAccountCard}
                                onClick={openDepositOptions}
                            >
                                {t('GenerateDepositDraft')}
                            </Button>
                        </Box>
                    )}


                </>
                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}

                <CustomDeleteConfirmationModal
                    isVisible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    onDelete={handleConfirmDelete}
                    confirmMessage={t('confirmDeleteMessage')}
                    titleMessage={t('confirmDeleteTitle')}
                />

                {editedItem && Object.keys(editedItem).length > 0 && editedItem.docType !== 'PaymentAcceptances' && (

                    <EditModal
                        editedItem={editedItem}
                        handleAccountChange={handleAccountChange}
                        isRange={isRange}
                        isClosedReportingMonth={isClosedReportingMonth}
                        accountCardOptions={accountCardOptions}
                        handleChange={handleChange}
                        handleDateChange={handleDateChange}
                        CustomInput2={CustomInput2}
                        setReportingMonthDate={setReportingMonthDate}
                        handleVatRadioChange={handleVatRadioChange}
                        statusCheck={statusCheck}
                        handleRadioChange={handleRadioChange}
                        type={'JournalEntries'}
                        editedAddAccountCard={editedAddAccountCard}
                        handleCloseEditAddNewAccountCardDocument={handleCloseEditAddNewAccountCardDocument}
                        handleEditAddAccountChange={handleEditAddAccountChange}
                        sortCodeIdOptions={sortCodeIdOptions}
                        debitAccountOptions={debitAccountOptions}
                        creditAccountOptions={creditAccountOptions}
                        handleUpdate={handleUpdate}
                        handleCancel={handleCancel}
                        handleDeleteClick={handleEditDeleteClick}
                        client={client}
                        token={token}
                        setAccountCardOptions={setAccountCardOptions}
                        setLoading={setLoading}
                        setEditedAddAccountCard={setEditedAddAccountCard}
                        setEditedItem={setEditedItem}
                        handleReopenEdit={handleReopenEdit}
                        showIframe={true}
                        palCodes={formattedPalCodeOptions}
                        fetchEnums={fetchEnums}
                        assets={assets}

                    />
                )}

            </>
        </>
    );
}


export default HoldingItems;
